'use client'

import { useEffect } from 'react'
import Modal from 'react-modal'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light'
import { faSliders } from '@awesome.me/kit-94e593bf23/icons/classic/light'

import SubmitWithPendingButton from '@/app/_components/SubmitWithPendingButton'

import '@/app/_styles/react-modal-slide-panel.css'

const MobileFiltersPanel = ({ open, onClose, productCount, isLoading, children }) => {

    useEffect(() => {
        Modal.setAppElement('#app')
    }, [])

    // Lock body scroll when panel is open
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
        return () => {
            document.body.style.overflow = ''
        }
    }, [open])

    // Build button text based on product count
    const getButtonText = () => {
        if (productCount === 0) {
            return 'No Products Found'
        }
        return `View Products (${productCount})`
    }

    return (
        <Modal
            overlayClassName="slide-panel lg:hidden fixed inset-0 outline-none z-40"
            className="fixed outline-none bg-white shadow-sm
                inset-0 top-[var(--header-height)] [body.header-collapsed_&]:top-[var(--header-height-collapsed)]"
            isOpen={open}
            onRequestClose={onClose}
            contentLabel="Filter Products"
            closeTimeoutMS={500}
        >
            <div className="h-full flex flex-col">
                {/* Header with title and close button */}
                <div className="shrink-0 flex items-center justify-between site-padding py-3 border-b border-gray-8 leading-none">
                    <div className="flex items-center">
                        <FontAwesomeIcon icon={faSliders} className="text-xl mr-2 block" width="16" />
                        <span className="text-md">Filter</span>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Close filters"
                        className="text-light hover:text-primary flex items-center"
                    >
                        <FontAwesomeIcon icon={faXmark} className="text-[28px] block" />
                    </button>
                </div>

                {/* Filter content - scrollable */}
                <div className="flex-1 overflow-y-auto overscroll-contain site-padding py-4">
                    {children}
                </div>

                {/* Sticky footer with View Products button */}
                <div className="shrink-0 site-padding py-4 bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]">
                    <SubmitWithPendingButton
                        type="button"
                        onClick={onClose}
                        isPending={isLoading}
                        pendingText="Loading..."
                        disabled={productCount === 0}
                        className="w-full"
                    >
                        {getButtonText()}
                    </SubmitWithPendingButton>
                </div>
            </div>
        </Modal>
    )
}

export default MobileFiltersPanel
